import { AlertTriangle, Loader2 } from "lucide-react";

/** Les trois états qu'un écran connecté doit toujours savoir montrer. */

export function Chargement({ message = "Chargement…" }: { message?: string }) {
  return (
    <div
      role="status"
      aria-live="polite"
      className="flex items-center gap-2 px-4 py-8 text-sm text-encre-douce"
    >
      <Loader2 className="h-4 w-4 animate-spin" aria-hidden />
      {message}
    </div>
  );
}

export function Erreur({ message, onReessayer }: { message: string; onReessayer?: () => void }) {
  return (
    <div
      role="alert"
      className="flex flex-col gap-3 rounded-[6px] border border-alerte/30 bg-alerte/5 px-4 py-3"
    >
      <p className="flex items-start gap-2 text-sm text-alerte">
        <AlertTriangle className="mt-0.5 h-4 w-4 shrink-0" aria-hidden />
        <span>{message}</span>
      </p>
      {onReessayer ? (
        <button
          type="button"
          onClick={onReessayer}
          className="self-start text-sm font-medium text-alerte underline underline-offset-4"
        >
          Réessayer
        </button>
      ) : null}
    </div>
  );
}

export function Vide({ titre, detail }: { titre: string; detail?: string }) {
  return (
    <div className="px-4 py-10 text-center">
      <p className="text-sm font-medium text-encre">{titre}</p>
      {detail ? <p className="mt-1 text-sm text-encre-douce">{detail}</p> : null}
    </div>
  );
}
